/**
 * Analytics utility for Google Analytics 4.
 * Tracking is DISABLED by default and only activates after user login.
 * On logout, tracking is completely disabled again.
 */

let _currentUserId = null;

const _getMeasurementId = () => process.env.GATSBY_GA4_MEASUREMENT_ID;

export const getGtag = () => {
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== "function") {
      window.gtag = function() { window.dataLayer.push(arguments); };
    }
    return window.gtag;
  }
  return () => {};
};

/**
 * Enable GA4 tracking and identify the user (call on login).
 */
export const identifyUser = (userId, properties = {}) => {
  _currentUserId = userId;
  const measurementId = _getMeasurementId();
  if (typeof window !== "undefined" && measurementId) {
    // Lift the ga-disable flag to allow tracking
    window[`ga-disable-${measurementId}`] = false;

    const gtag = getGtag();
    
    // Globally SET the user_id so all automatic events (like page_view) pick it up
    gtag("set", { user_id: userId });

    gtag("config", measurementId, {
      user_id: userId,
      send_page_view: false,
      ...properties,
    });
  }
};

/**
 * Track a custom event (only fires if user is logged in).
 */
export const trackEvent = (eventName, properties = {}) => {
  if (!_currentUserId) return; // Do nothing if not logged in
  const gtag = getGtag();
  gtag("event", eventName, {
    ...properties,
    user_id: _currentUserId,
  });
};

/**
 * Disable all tracking and clear user identity (call on logout).
 */
export const resetAnalytics = () => {
  _currentUserId = null;
  const measurementId = _getMeasurementId();
  if (typeof window !== "undefined" && measurementId) {
    // Clear global user_id
    const gtag = getGtag();
    gtag("set", { user_id: undefined });

    // Re-enable the ga-disable flag to block all tracking
    window[`ga-disable-${measurementId}`] = true;
  }
};
